import * as React from "react";
import styled from "styled-components";
import { HTMLRenderer } from "../../../../../../course-author/html-editor/Renderer";
import { IClozeGapLocalized } from "../../../../../../course-author/types";
import GapPreview from "./GapAnswers";

const ClozePreviewContainer = styled.div`
  align-items: center;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  height: 15rem;
  width: 100%;
`;

export interface IClozePreviewProps {
  pieces: Array<{
    prefix: string;
    gap: IClozeGapLocalized;
  }>;
}

const ClozePreview: React.FunctionComponent<IClozePreviewProps> = ({ pieces }) => {
  return (
    <ClozePreviewContainer>
      {pieces.map(({ prefix, gap }, i) => (
        <React.Fragment key={i}>
          <HTMLRenderer source={prefix} />
          {gap && i !== pieces.length - 1 && <GapPreview gap={gap} />}
        </React.Fragment>
      ))}
    </ClozePreviewContainer>
  );
};

export default ClozePreview;
